function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import propsToCss from '../utils/propsToCss';
import { basePropTypes, handleProps } from './utils';
const StyledLink = styled(Link)`
  cursor: pointer;
  ${props => propsToCss(props)}
`;
const StyledAnchor = styled.a`
  cursor: pointer;
  ${props => propsToCss(props)}
`;
const LinkButton = ({
  children,
  text,
  to,
  ...rest
}) => {
  if (!to) {
    return null;
  }
  if (to.startsWith('http')) {
    return /*#__PURE__*/React.createElement(StyledAnchor, _extends({}, handleProps(rest), {
      href: to
    }), children || text);
  }
  return /*#__PURE__*/React.createElement(StyledLink, _extends({}, handleProps(rest), {
    to: to
  }), children || text);
};
LinkButton.propTypes = basePropTypes;
export default LinkButton;